import { Dialog, DialogPanel } from '@headlessui/react';
import IconSvg from '../ui/IconSvg';
import { useNavigate, useParams } from 'react-router-dom';

interface Props {
  isOpen: boolean;
  onClose: (value: boolean) => void;
  mintedKeys: number[];
}

function ArenaMintSuccessModal({ isOpen, onClose, mintedKeys }: Props) {
  const { id } = useParams();
  const navigate = useNavigate();
  const keys = mintedKeys;
  const getMaxWidth = (keys: number) => {
    switch (keys) {
      case 1:
        return '489px';
      case 2:
      case 3:
      case 5:
        return '806px';
      case 4:
        return '526px';
      default:
        return '806px';
    }
  };

  const getCardDimensions = (keys: number) => {
    switch (keys) {
      case 1:
        return { width: '498px', height: '498px' };
      case 2:
        return { width: '389px', height: '389px' };
      case 3:
      case 4:
      case 5:
        return { width: '249px', height: '249px' };
      default:
        return { width: '249px', height: '249px' };
    }
  };

  const maxWidth = getMaxWidth(keys);
  const { width: cardWidth, height: cardHeight } = getCardDimensions(keys);
  return (
    <>
      <Dialog open={isOpen} as="div" className="relative z-10 focus:outline-none" onClose={onClose}>
        <div className="fixed inset-0 z-10 w-screen overflow-y-auto bg-grayscale-900/50">
          <div className="flex items-center justify-center min-h-full p-4">
            <DialogPanel
              transition
              className="relative w-full p-10 border-2 rounded-md max-w-fit bg-grayscale-800 border-grayscale-700"
            >
              <button className="absolute top-[11px] right-[13px]" onClick={() => onClose(false)}>
                <IconSvg icon="closeM" className="text-grayscale-400" />
              </button>

              <div className="max-w-[498px]" style={{ maxWidth }}>
                <div className="text-center mb-[30px] space-y-3.5">
                  <h3 className="uppercase text-brand-primary-light leading-[40px]">
                    successfully claimed
                  </h3>

                  <p className="text-grayscale-400">
                    Congratulations! Your key has been successfully claimed. You can check it out on
                    your Profile Page or use it To Open The Box!
                  </p>
                </div>

                <div className="mb-[27px] flex flex-wrap items-center justify-center gap-7">
                  {mintedKeys &&
                    mintedKeys.length > 0 &&
                    mintedKeys?.map(
                      (key, index) =>
                        key > 0 && (
                          <div key={index} className="relative">
                            <p className="absolute w-6 h-6 text-sm font-medium text-center text-white bg-black rounded-md top-2 left-2">
                              {key}
                            </p>
                            <img
                              src={`/assets/images/arenaKeys/${index}.png`}
                              className="rounded-md "
                              style={{
                                width: cardWidth,
                                height: cardHeight,
                              }}
                            />
                          </div>
                        ),
                    )}
                </div>

                <div className="flex items-center justify-center gap-6 mb-[17px]">
                  <button onClick={() => navigate(`/arena/openbox/${id}`)}>
                    <svg
                      width="185"
                      height="48"
                      viewBox="0 0 185 48"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.33333 48V44.1081H3.66667V40.2162H0V7.78378H3.66667V3.89189H7.33333V0H11V48H7.33333Z"
                        fill="#B73FFF"
                      />
                      <rect width="165" height="48" transform="translate(10)" fill="#B73FFF" />
                      <path
                        d="M49.2281 30.18C48.3881 30.18 47.6561 30.024 47.0321 29.712C46.4201 29.388 45.9461 28.938 45.6101 28.362C45.2861 27.774 45.1241 27.084 45.1241 26.292V20.568C45.1241 19.776 45.2861 19.092 45.6101 18.516C45.9461 17.928 46.4201 17.478 47.0321 17.166C47.6561 16.842 48.3881 16.68 49.2281 16.68C50.0801 16.68 50.8121 16.842 51.4241 17.166C52.0361 17.478 52.5041 17.928 52.8281 18.516C53.1641 19.092 53.3321 19.77 53.3321 20.55V26.292C53.3321 27.084 53.1641 27.774 52.8281 28.362C52.5041 28.938 52.0361 29.388 51.4241 29.712C50.8121 30.024 50.0801 30.18 49.2281 30.18ZM49.2281 28.2C49.8401 28.2 50.3021 28.038 50.6141 27.714C50.9261 27.378 51.0821 26.904 51.0821 26.292V20.568C51.0821 19.944 50.9261 19.47 50.6141 19.146C50.3021 18.822 49.8401 18.66 49.2281 18.66C48.6161 18.66 48.1541 18.822 47.8421 19.146C47.5301 19.47 47.3741 19.944 47.3741 20.568V26.292C47.3741 26.904 47.5301 27.378 47.8421 27.714C48.1661 28.038 48.6281 28.2 49.2281 28.2ZM56.0071 33.24V20.1H58.2031V21.99H58.7071L58.2031 22.512C58.2031 21.708 58.4431 21.078 58.9231 20.622C59.4031 20.154 60.0511 19.92 60.8671 19.92C61.8631 19.92 62.6611 20.262 63.2611 20.946C63.8611 21.63 64.1611 22.548 64.1611 23.7V26.382C64.1611 27.15 64.0231 27.822 63.7471 28.398C63.4831 28.962 63.1051 29.4 62.6131 29.712C62.1211 30.024 61.5391 30.18 60.8671 30.18C60.0511 30.18 59.4031 29.952 58.9231 29.496C58.4431 29.028 58.2031 28.392 58.2031 27.588L58.7071 28.11H58.1851L58.2571 30.468V33.24H56.0071ZM60.0751 28.236C60.6511 28.236 61.1011 28.068 61.4251 27.732C61.7491 27.396 61.9111 26.916 61.9111 26.292V23.808C61.9111 23.184 61.7491 22.704 61.4251 22.368C61.1011 22.032 60.6511 21.864 60.0751 21.864C59.5111 21.864 59.0671 22.038 58.7431 22.386C58.4191 22.722 58.2571 23.196 58.2571 23.808V26.292C58.2571 26.904 58.4191 27.384 58.7431 27.732C59.0671 28.068 59.5111 28.236 60.0751 28.236ZM70.8321 30.18C69.9921 30.18 69.2601 30.018 68.6361 29.694C68.0121 29.37 67.5261 28.92 67.1781 28.344C66.8421 27.756 66.6741 27.072 66.6741 26.292V23.808C66.6741 23.028 66.8421 22.35 67.1781 21.774C67.5261 21.186 68.0121 20.73 68.6361 20.406C69.2601 20.082 69.9921 19.92 70.8321 19.92C71.6601 19.92 72.3801 20.082 72.9921 20.406C73.6161 20.73 74.0961 21.186 74.4321 21.774C74.7801 22.35 74.9541 23.028 74.9541 23.808V25.59H68.8521V26.292C68.8521 26.988 69.0201 27.516 69.3561 27.876C69.6921 28.224 70.1901 28.398 70.8501 28.398C71.3541 28.398 71.7621 28.314 72.0741 28.146C72.3861 27.966 72.5841 27.708 72.6681 27.372H74.8821C74.7141 28.224 74.2581 28.908 73.5141 29.424C72.7821 29.928 71.8881 30.18 70.8321 30.18ZM72.7761 24.33V23.79C72.7761 23.106 72.6141 22.584 72.2901 22.224C71.9661 21.852 71.4801 21.666 70.8321 21.666C70.1841 21.666 69.6921 21.852 69.3561 22.224C69.0201 22.596 68.8521 23.124 68.8521 23.808V24.186L72.9381 24.15L72.7761 24.33ZM77.593 30V20.1H79.789V21.99H80.401L79.789 22.512C79.789 21.696 80.023 21.06 80.491 20.604C80.971 20.148 81.625 19.92 82.453 19.92C83.425 19.92 84.199 20.244 84.775 20.892C85.363 21.54 85.657 22.41 85.657 23.502V30H83.407V23.736C83.407 23.136 83.251 22.674 82.939 22.35C82.627 22.026 82.189 21.864 81.625 21.864C81.073 21.864 80.635 22.032 80.311 22.368C79.999 22.704 79.843 23.184 79.843 23.808V30H77.593ZM104.039 30.18C103.223 30.18 102.575 29.952 102.095 29.496C101.615 29.028 101.375 28.392 101.375 27.588L101.879 28.11H101.375V30H99.179V16.86H101.429V19.632L101.357 21.99H101.879L101.375 22.512C101.375 21.708 101.615 21.078 102.095 20.622C102.575 20.154 103.223 19.92 104.039 19.92C105.035 19.92 105.833 20.262 106.433 20.946C107.033 21.63 107.333 22.554 107.333 23.718V26.4C107.333 27.552 107.033 28.47 106.433 29.154C105.833 29.838 105.035 30.18 104.039 30.18ZM103.247 28.236C103.823 28.236 104.273 28.068 104.597 27.732C104.921 27.396 105.083 26.916 105.083 26.292V23.808C105.083 23.184 104.921 22.704 104.597 22.368C104.273 22.032 103.823 21.864 103.247 21.864C102.683 21.864 102.239 22.038 101.915 22.386C101.591 22.722 101.429 23.196 101.429 23.808V26.292C101.429 26.904 101.591 27.384 101.915 27.732C102.239 28.068 102.683 28.236 103.247 28.236ZM113.986 30.162C113.146 30.162 112.414 30.006 111.79 29.694C111.178 29.37 110.698 28.92 110.35 28.344C110.014 27.756 109.846 27.066 109.846 26.274V23.826C109.846 23.034 110.014 22.35 110.35 21.774C110.698 21.186 111.178 20.736 111.79 20.424C112.414 20.1 113.146 19.938 113.986 19.938C114.838 19.938 115.57 20.1 116.182 20.424C116.794 20.736 117.268 21.186 117.604 21.774C117.952 22.35 118.126 23.028 118.126 23.808V26.274C118.126 27.066 117.952 27.756 117.604 28.344C117.268 28.92 116.794 29.37 116.182 29.694C115.57 30.006 114.838 30.162 113.986 30.162ZM113.986 28.2C114.586 28.2 115.048 28.038 115.372 27.714C115.708 27.378 115.876 26.898 115.876 26.274V23.826C115.876 23.19 115.708 22.71 115.372 22.386C115.048 22.062 114.586 21.9 113.986 21.9C113.398 21.9 112.936 22.062 112.6 22.386C112.264 22.71 112.096 23.19 112.096 23.826V26.274C112.096 26.898 112.264 27.378 112.6 27.714C112.936 28.038 113.398 28.2 113.986 28.2ZM120.027 30L123.483 24.888L120.261 20.1H122.799L124.329 22.53C124.425 22.674 124.509 22.836 124.581 23.016C124.665 23.196 124.731 23.34 124.779 23.448C124.827 23.34 124.893 23.196 124.977 23.016C125.061 22.836 125.145 22.674 125.229 22.53L126.777 20.1H129.315L126.093 24.888L129.531 30H126.975L125.265 27.282C125.169 27.126 125.079 26.958 124.995 26.778C124.911 26.598 124.839 26.454 124.779 26.346C124.731 26.454 124.665 26.598 124.581 26.778C124.497 26.958 124.407 27.126 124.311 27.282L122.565 30H120.027Z"
                        fill="black"
                      />
                      <path
                        d="M177.667 48V44.1081H181.333V40.2162H185V7.78378H181.333V3.89189H177.667V0H174V48H177.667Z"
                        fill="#B73FFF"
                      />
                    </svg>
                  </button>
                </div>

                <div className="flex gap-[5px] items-center justify-center">
                  <div className="text-sm text-gray-300">Points earned</div>
                  <IconSvg icon="starS" />
                  <div className="text-lg font-semibold text-grayscale-100">110</div>
                </div>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>
    </>
  );
}

export default ArenaMintSuccessModal;
